import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { cn } from "design-system/utils"
import { LanguageEnum } from "lopermut"
import { useTranslation } from "react-i18next"

type Props = {
  locale?: string | null
  preferredLocale?: string | null
}

export function CustomerLocale({ locale, preferredLocale }: Props) {
  const { t } = useTranslation()
  const hasPreferredLocale = Boolean(preferredLocale)
  const effectiveLocale = preferredLocale || locale

  if (!effectiveLocale) {
    return <span className="text-muted-foreground">{"-"}</span>
  }

  const formattedLanguage = LanguageEnum[effectiveLocale]

  return (
    <Tooltip>
      <TooltipTrigger className="cursor-pointer">
        <span className={cn(!formattedLanguage && "text-muted-foreground font-mono")}>
          {formattedLanguage ?? effectiveLocale}
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <div className="flex flex-col gap-1 text-xs">
          <span>
            {hasPreferredLocale
              ? t("shared.customerLocale.usingPreferred")
              : t("shared.customerLocale.usingDefault")}
          </span>
          {hasPreferredLocale && (
            <span>
              {t("shared.customerLocale.preferred")}
              {": "}
              <span className="font-mono">{preferredLocale}</span>
            </span>
          )}
          {locale && (
            <span>
              {t("shared.customerLocale.default")}
              {": "}
              <span className="font-mono">{locale}</span>
            </span>
          )}
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
